import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "plusCircleFilled"
const PlusCircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12 22.5 17.255 18.64 21.61 13.599 22.38Q13.078 22.457 12.54 22.485 12.272 22.5 12 22.5C6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5M11.063 5.636V11.063H5.636V12.937H11.063V18.365H12.937V12.937H18.365V11.064H12.937V5.636z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PlusCircleFilledIcon
